import { Stack, Tab, Tabs, Typography } from '@mui/material';
import {
  createFileRoute,
  Outlet,
  redirect,
  useLocation,
  useNavigate
} from '@tanstack/react-router';

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate({ from: Route.fullPath });

  const onPlansTab = () => navigate({ to: '/auto-force-outs' });
  const onParticipantsTab = () =>
    navigate({ to: '/auto-force-outs/participants' });

  const tab = location.pathname.startsWith('/auto-force-outs/participants')
    ? 'participants'
    : 'plans';

  return (
    <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
      <Typography variant='h5'>Auto Force Outs</Typography>

      <Tabs value={tab}>
        <Tab
          data-testid='autoForceOutsPlansTab'
          label='Plans'
          onClick={onPlansTab}
          value='plans'
        />
        <Tab
          data-testid='autoForceOutsParticipantsTab'
          label='Participants'
          onClick={onParticipantsTab}
          value='participants'
        />
      </Tabs>

      <Outlet />
    </Stack>
  );
};

export const Route = createFileRoute('/auto-force-outs')({
  beforeLoad: () => {
    if (localStorage.getItem('isAdmin') !== '1') {
      throw redirect({ to: '/organizations' });
    }
  },
  component: Layout
});
